import React from "react";
import { useLayoutStore } from "../../stores/useLayoutStore";
import { LAYOUT_MODE_TYPES } from "../../Components/constants/layout";

/**
 * Wrapper pour les pages d'authentification (ForgetPassword, Login générique).
 * Fournit le fond décoratif des pages auth et un bouton thème en haut à droite.
 */
const ParticlesAuth = ({ children }: { children: React.ReactNode }) => {
  const layoutModeType = useLayoutStore((s) => s.layoutModeType);
  const changeLayoutMode = useLayoutStore((s) => s.changeLayoutMode);

  const nextMode =
    layoutModeType === LAYOUT_MODE_TYPES.DARKMODE
      ? LAYOUT_MODE_TYPES.LIGHTMODE
      : LAYOUT_MODE_TYPES.DARKMODE;

  const isDarkMode = layoutModeType === LAYOUT_MODE_TYPES.DARKMODE;
  const themeIcon = isDarkMode ? "ri-sun-line" : "ri-moon-line";
  const themeTitle = isDarkMode ? "Passer en mode clair" : "Passer en mode sombre";

  const handleToggleTheme = () => {
    changeLayoutMode(nextMode);
  };

  return (
    <div className="auth-page-wrapper pt-5">
      <div className="auth-one-bg-position auth-one-bg">
        <div className="bg-overlay"></div>
      </div>
      <div
        className="position-absolute top-0 end-0 p-3"
        style={{ zIndex: 10 }}
      >
        <button
          type="button"
          className="btn btn-icon btn-ghost-secondary rounded-circle shadow-sm"
          onClick={handleToggleTheme}
          title={themeTitle}
          style={{
            width: "42px",
            height: "42px",
            backgroundColor: "rgba(255,255,255,0.15)",
            border: "1px solid rgba(255,255,255,0.2)",
            color: "#fff",
          }}
        >
          <i className={`${themeIcon} fs-22`}></i>
        </button>
      </div>
      {children}
    </div>
  );
};

export default ParticlesAuth;
